import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import SubtleBadge from '@/components/common/SubtleBadge';
import type { ReactNode } from 'react';

interface CrawlStatusCheckerProps {
  children?: ReactNode;
  crawl_status?: number | null;
}

const CrawlStatusChecker = ({
  children,
  crawl_status
}: CrawlStatusCheckerProps): React.JSX.Element => {
  return (
    <>
      {crawl_status !== 5 && crawl_status !== 0 ? (
        children
      ) : (
        <SubtleBadge
          pill
          bg="warning"
          className="d-inline fs--2"
        >
          <FontAwesomeIcon
            icon="stream"
            transform="shrink-2"
            className="mx-1"
          />
          درحال خزش
        </SubtleBadge>
      )}
    </>
  );
};

export default CrawlStatusChecker;
// داده‌ها این بخش بعد از اتمام خزش نمایش داده میشه
